import { Controller } from "@hotwired/stimulus";

export default class UserSelectorController extends Controller {
  connect() {
    this.userSelect();
  }

  async userSelect() {
    this.form = document.getElementById(this.element.dataset.formId);
    this.fieldName = this.element.dataset.fieldName;
    this.maxUsers = this.element.dataset.maxUsers ? Number.parseInt(this.element.dataset.maxUsers, 10) : null;
    this.selectedUserIds = this.form
      ? [...this.form.querySelectorAll(`input[name="${this.fieldName}"]`)]
        .map((i) => i.value.trim())
        .filter(Boolean)
      : [];

    const turboRequest = await this.loadTurboRequest();
    await turboRequest("/user_selections/all_selected_users", {
      method: "POST",
      params: {
        user_ids: this.selectedUserIds,
        field_name: this.fieldName,
        current_user_id: this.element.dataset.currentUserId,
        owner_id: this.element.dataset.ownerId
      },
      turboStream: true,
    });

    const checkboxes = this.element.querySelectorAll(
      "input[type=\"checkbox\"][data-user-id]",
    );
    for (const checkbox of checkboxes) {
      if (this.selectedUserIds.includes(checkbox.dataset.userId)) {
        checkbox.checked = true;
      }
    }
    $(".target_people_error").addClass("d-none");
  }

  async searchInput(e) {
    clearTimeout(this.searchTimeout);

    const searchValue = e.currentTarget.value.trim();
    this.searchTimeout = setTimeout(async () => {
      await this.loadUsers(searchValue);
    }, 300);
  }

  submitSearch() {
    const form = this.element.querySelector("#user-search-form");
    if (!form) return;

    for (const i of form.querySelectorAll("input[name=\"selected_ids[]\"]")) {
      i.remove();
    }
    for (const id of this.selectedUserIds) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "selected_ids[]";
      input.value = id;
      form.appendChild(input);
    }

    form.requestSubmit();
  }

  async toggle(e) {
    $(".target_user_error").addClass("d-none");
    const id = e.target.value;

    if (e.target.checked && this.maxUsers && this.selectedUserIds.length >= this.maxUsers) {
      e.target.checked = false;
      alert(`You can select up to ${this.maxUsers} people.`);
      return;
    }

    if (!e.target.checked && this.handleProtectedUser(id)) {
      e.target.checked = true;
      return;
    }

    if (e.target.checked) {
      if (!this.selectedUserIds.includes(id)) {
        this.selectedUserIds.push(id);
        const turboRequest = await this.loadTurboRequest();
        const params = new URLSearchParams();
        params.append("field_name", this.fieldName);
        await turboRequest(`/user_selections/${id}/select?${params.toString()}`, {
          method: "GET",
          turboStream: true,
        });
      }
    } else {
      this.removeSelectedUser(id);
    }
    this.updateSelectedUserCount();
  }

  removeSelectedUser(id) {
    if (this.handleProtectedUser(id)) return;

    this.selectedUserIds = this.selectedUserIds.filter((i) => i !== id);
    const el = document.getElementById(`selected-user-${id}`);
    if (el) el.remove();
    this.updateSelectedUserCount();
  }

  removeFromTop(event) {
    const id = event.currentTarget.dataset.id;
    if (this.handleProtectedUser(id)) return;

    this.removeSelectedUser(id);
    const checkbox = this.element.querySelector(
      `input[type="checkbox"][value="${id}"]`,
    );
    if (checkbox) checkbox.checked = false;
  }

  async confirm() {
    const errorDiv = $(".target_user_error");
    if (this.selectedUserIds.length > 0) {
      errorDiv.addClass("d-none");
      const turboRequest = await this.loadTurboRequest();
      await turboRequest("/user_selections/selected_users", {
        method: "POST",
        params: {
          user_ids: this.selectedUserIds,
          field_name: this.fieldName
        },
        turboStream: false,
        onSuccess: (result, response) => {
          this.close();
        },
      });
    } else {
      errorDiv.removeClass("d-none");
    }
  }

  async loadUsers(searchValue = "") {
    const params = new URLSearchParams();

    for (const id of this.selectedUserIds) {
      params.append("selected_ids[]", id);
    }

    const filterValue = this.element.querySelector("input[name=\"filter\"]:checked")?.value;

    if (filterValue && filterValue !== "all") {
      params.append("filter", filterValue);
    }
    params.append("field_name", this.fieldName);

    if (searchValue) {
      params.append("search", searchValue);
    }

    const turboRequest = await this.loadTurboRequest();

    await turboRequest(`/user_selections?${params.toString()}`, {
      method: "GET",
      turboStream: true,
    });
  }

  async applyFilter(e) {
    const searchInput = this.element.querySelector(
      "#user-search-form input[name=\"search\"]"
    );

    await this.loadUsers(searchInput?.value.trim() || "");
  }

  close() {
    bootstrap.Modal.getInstance(this.element.closest(".modal")).hide();
  }

  async loadTurboRequest() {
    const turboRequest = (await import("../helpers/api")).turboRequest;
    return turboRequest;
  }

  protectedUserMessage(id) {
    if (id === this.element.dataset.ownerId) {
      return "You can't remove group owner from the group.";
    }

    if (id === this.element.dataset.currentUserId) {
      return "You cannot remove yourself from the group.";
    }

    return null;
  }

  handleProtectedUser(id) {
    const message = this.protectedUserMessage(id);
    if (message) {
      alert(message);
      return true;
    }

    return false;
  }

  updateSelectedUserCount() {
    const countElement = this.element.querySelector("#user-count-number");
    if (!countElement) return;

    countElement.textContent = `Selected: ${this.selectedUserIds.length}`;
  }
}
